import React from 'react';
import classnames from 'classnames';

import s from './PreviewThumb.scss';

export interface Props {
  className?: string;
  dragging?: boolean;
  selected?: boolean;
  draggable?: boolean;
  onClick?: () => void;
}

const PreviewThumb: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
  draggable,
  dragging,
  selected,
  onClick,
}) => {
  return (
    <div
      className={classnames(
        s['root'],
        selected && s['selected'],
        draggable && s['draggable'],
        dragging && s['dragging'],
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
PreviewThumb.displayName = 'PreviewThumb';

export default PreviewThumb;
